import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { VehicleOfferRentSearchResultsProps } from "./types";
import { useTranslate } from "helpers";
import { FLEET_VEHICLE_OFFER_RENT_SEARCH_COLUMNS } from "./consts";


const VehicleOfferRentSearchResults: React.FC<
  VehicleOfferRentSearchResultsProps
> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onContactClick,
    onDeleteClick,
  } = props;

  const { t } = useTranslate();
  return (
    <>
      <TableSearch
        columns={FLEET_VEHICLE_OFFER_RENT_SEARCH_COLUMNS(t, onContactClick, onDeleteClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}


      />
    </>
  );
};
export default memo(VehicleOfferRentSearchResults);
